import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguagesSwitcherData } from './languageSwitcher.interface';


@Component({
  selector: 'app-language-switcher',
  templateUrl: './language-switcher.component.html',
  styleUrls: ['./language-switcher.component.scss']
})
export class LanguageSwitcherComponent {

  languagesSwitcherData: LanguagesSwitcherData = {languagesList:['it','en']};


  constructor(public translate: TranslateService) {
    translate.addLangs(this.languagesSwitcherData?.languagesList);
    translate.setDefaultLang('en');
  }

  switchLang(lang: string) {
    this.translate.use(lang);
  }

}
